<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <!-- Brand -->
        <router-link :to="{name: 'changePassword'}" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          Change Password
        </router-link>
        <user-data></user-data>
        
      </div>
    </nav>
    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row mb-5 mb-xl-0">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Change Password</h3>
                </div>
              </div>
            </div>
            <div class="row m-0">
                <div class="col-md-8 pb-4">
                  <b-form @submit.prevent="changePasswordAPI">
                    <b-form-group horizontal label="Current Password" label-class="text-sm-right" label-for="currentPassword">
                        <b-form-input id="currentPassword" type="password" 
                            class="form-control-alternative" 
                            placeholder="Please enter your current password" 
                            v-model="form.curPassword" required></b-form-input>
                    </b-form-group>
                    <b-form-group horizontal label="New Password" label-class="text-sm-right" label-for="newPassword">
                        <b-form-input id="newPassword" type="password" 
                        class="form-control-alternative" 
                        placeholder="Please enter your new password" 
                        v-model="form.password" required></b-form-input>
                    </b-form-group>
                    <b-form-group horizontal label="Confirm Password" label-class="text-sm-right" label-for="confirmPassword">
                        <b-form-input id="confirmPassword" type="password" 
                        class="form-control-alternative"
                        placeholder="Please re-enter your new password" 
                        v-model="form.confirmPassword" required></b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="success" :disabled="loader || !form.curPassword || !form.confirmPassword || !form.password">Submit</b-button>
                    <b-button class="text-danger" type="button" @click="$router.go(-1)">Cancel</b-button>
                  </b-form>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import datePicker from 'vue-bootstrap-datetimepicker';
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
  import userData from '@/pages/Common/userData';
import { mapActions } from 'vuex';

  export default {
    components: {
      userData,
      datePicker
    },
    data () {
      return {
        options: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
        },
        loader: false,
        form : {
          password: null,
          confirmPassword: null,
          curPassword: null
        },
        meterTypes: [
            { text: 'Select One', value: null },
            { text: 'Gas', value: 1 },
            { text: 'Electricity', value: 2 },
            { text: 'Water', value: 3 },
        ],
        sessions: [
          { text: 'Select One', value: null },
          'Le Merit (GAS)', 'Le Merit (Electricity)', 'Le Merit (Water)',
        ],
        fields: [
          {
            key: 'lotNo',
            label: 'Lot No',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'ownerName',
            label: 'Owner Name',
            sortable: true
          },
          {
            key: 'meterType',
            label: 'Meter Type',
            sortable: true,
          },
          {
            key: 'date',
            label: 'Date',
            sortable: true,
          },
          {
            key: 'billValue',
            label: 'Bill Value',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Actions',
            sortable: false,
          },
        ],
        items: [
          {lotNo:1, ownerName: 'Owner Name', meterType: 'Gas', date: '10/10/2018', billValue: 250},
          {lotNo:2, ownerName: 'Owner Name', meterType: 'Water', date: '11/10/2018', billValue: 68},
          {lotNo:3, ownerName: 'Owner Name', meterType: 'Electricity', date: '13/10/2018', billValue: 235 },
        ]
      }
    },
    methods: {
      ...mapActions('authentication', ['CHANGE_ADMIN_PASSWORD']),
      changePasswordAPI () {
        if (this.form.password === this.form.confirmPassword) {
          this.loader = true
          this.CHANGE_ADMIN_PASSWORD(this.form).then(() => {
            this.loader = false
            this.$router.push({name: 'adminLogin'})
          }).catch(() => {
            this.loader = false
          })
        } else {
          this.ERROR_TOAST_MSG('confirm password must be same as new password')
        }
      }
    },
    created () {
      if (!localStorage.token) {
        localStorage.clear()
        next({
          name: 'adminLogin'
        })
      } else {
        if(localStorage.roleId == 1){
          this.$router.replace({name: "dashboard"});
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Admin/changePassword.vue